var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"code"},[_vm._v("  "),_c('code',[_vm._v("\n    "),_vm._t("default"),_vm._v("\n  ")],2),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }